import Entity from "../entity";

export default class ProviderMarkup  extends Entity<number>{
    metaSearchAgencyId: string;
    fixedMarkup: number;
    percentageMarkup: number;
    currencyId: any;
    companyId: string;
    company: any;
    metaSearchAgency: any;
    fromAirportId: string;
    toAirportId: string;
}
